<template>
  <!-- nếu dataRow là subheader thì chỉ hiển thị dạng text, không fommat theo columnType -->
  <tr
    v-if="(!dataRow.isHide || !groupField) && dataRow.is_subheader == true"
    :class="[
      'ms-tr ms-tr-grid-viewer',
      isUseDataRowStyle && dataRow.IsBold ? 'ms-format-bold' : '',
      isUseDataRowStyle && dataRow.IsItalic ? 'ms-format-italic' : '',
      isUseDataRowStyle && dataRow.is_bold ? 'ms-format-bold' : '',
      isUseDataRowStyle && dataRow.is_italic ? 'ms-format-italic' : '',
      isUseDataRowStyle && dataRow.is_capital ? 'ms-format-capital' : '',
      {'action-hover': showRowAction && actionInline},
    ]"
    tabindex="0"
    :indexRow="dataRow.rowIndex || index"
    @keydown="row_keydown"
  >
    <td
      v-for="(col, index) in columnx"
      :key="col.dataField"
      :ref="`td-${col.dataField}`"
      class="ms-td ms-col-td ms-td-custom-sub-header"
      :class="[
        col.cssCellClass,
        {sticky: hasLockColumn && col.lock},
        index === columns?.length - 1 ? 'ms-col-td-last' : '',
        col.dataField,
      ]"
      :style="styleWidth(col, false, dataRow)"
      :colspan="col.colspan"
      :rowspan="col.rowspan"
    >
      <div
        :class="[
          `text-${col.align || 'left'}`,
          col.cssClass,
          'text-overflow',
          $ms.constant.FormatType.Checkbox,
          col.formatType,
        ]"
        :title="titleToolTip(dataRow, col)"
        data-animation="animated bounceInDown"
        data-toggle="tooltip"
      >
        <span
          :ref="`text-${col.dataField}`"
          class="ms-td-normal-span custom-check-display text-center"
          :title="dataRow[col.dataField]"
          @click="viewLinkedForm(col, dataRow)"
        >
          {{ dataRow[col.dataField] }}
        </span>
      </div>
    </td>
  </tr>
  <tr
    v-else-if="(!dataRow.isHide || !groupField) && !dataRow.is_subheader"
    :class="[
      'ms-tr ms-tr-grid-viewer',
      isUseDataRowStyle && dataRow.IsBold ? 'ms-format-bold' : '',
      isUseDataRowStyle && dataRow.IsItalic ? 'ms-format-italic' : '',
      isUseDataRowStyle && dataRow.is_bold ? 'ms-format-bold' : '',
      isUseDataRowStyle && dataRow.is_italic ? 'ms-format-italic' : '',
      isUseDataRowStyle && dataRow.is_capital ? 'ms-format-capital' : '',
      {'action-hover': showRowAction && actionInline},
    ]"
    tabindex="0"
    :indexRow="dataRow.rowIndex || index"
    @keydown="row_keydown"
  >
    <td v-if="multiple" class="ms-td multiple-cell sticky ms-col-td-multiple">
      <ms-checkbox
        ref="multiple"
        :key="0"
        :checked="isChecked"
        :data-row="dataRow"
        class="justify-center"
        check-only
        :disabled="
          disabledCheckedMultipleTbody || disabled || dataRow.isDisabledCheckBox || dataRow.isDisabledCheckBoxCustom
        "
        @input="checkMultiple"
      />
    </td>
    <td v-if="serial" :key="0" class="ms-td serial text-center" :class="{sticky: hasLockColumn}">
      {{ pageSize * (currentPage - 1) + index + 1 }}
    </td>
    <td
      v-for="(col, index) in columnx"
      :key="col.dataField"
      :ref="`td-${col.dataField}`"
      class="ms-td ms-col-td"
      :class="[
        col.cssCellClass,
        {sticky: hasLockColumn && col.lock},
        index === columns?.length - 1 ? 'ms-col-td-last' : '',
      ]"
      :style="styleWidth(col, false, dataRow)"
      :colspan="col.colspan"
      :rowspan="col.rowspan"
    >
      <component
        :is="col.template"
        v-if="col.template"
        :data="dataRow"
        :column="col"
        :data-row="dataRow"
        :col="col"
        :row-selected="rowSelected"
        :is-selected="isSelected"
      />
      <div v-else-if="col.isSerial" :class="[`justify-center`, col.cssClass]">
        <span>{{ index + 1 }}</span>
      </div>

      <!-- Kiểu Text nhưng có dạng nhiều dòng value= MORE_DETAILS-->
      <div
        v-else-if="dataRow[col.dataField] === 'MORE_DETAILS'"
        :class="[`text-${col.align || 'left'}`, col.cssClass, 'text-overflow', 'icon24', 'more-rows']"
        :title="titleToolTip(dataRow, col)"
        data-animation="animated bounceInDown"
        data-toggle="tooltip"
        @click="viewMoreDetails(col, dataRow)"
      >
        <span />
      </div>
      <div
        v-else
        :class="[
          `text-${col.align || 'left'}`,
          col.cssClass,
          'text-overflow',
          $ms.constant.FormatType.Checkbox,
          col.formatType,
        ]"
        :title="titleToolTip(dataRow, col)"
        data-animation="animated bounceInDown"
        data-toggle="tooltip"
      >
        <!-- v-tooltip="{ content:titleToolTip(dataRow, col), placement: 'top'}" -->
        <!-- kiểu checkbox -->
        <span
          v-if="col.formatType === $ms.constant.FormatType.Checkbox"
          :ref="`text-${col.dataField}`"
          class="cell-checkbox"
        >
          <div class="icon" :class="{checked: dataRow[col.dataField]}" />
        </span>
        <!-- kiểu html -->
        <div
          v-else-if="col.formatType === $ms.constant.FormatType.Html"
          class="customStyleHtml"
          @click="customHtmlAction(col, dataRow)"
        >
          <span
            v-html="dataRow[col.dataField]"
            :title="
              $ms.format.formatData(dataRow[col.dataField], {
                formatType: col.formatType,
                optionFormat: col.optionFormat,
                enumName: col.enum,
              })
            "
          />
        </div>
        <span
          v-else
          :ref="`text-${col.dataField}`"
          :class="[
            `text-${dataRow.is_merge && col.dataField == mergeDataField ? 'left' : col.align || 'left'} ${
              col.linkedForm && !dataRow.disabled_link_form ? 'text-link' : ''
            }`,
            //Nếu dataRow có trường is_black thì cho class text-black
            dataRow.is_black ? 'text-black' : '',
          ]"
          class="ms-td-normal-span custom-check-display"
          :title="
            $ms.format.formatData(dataRow[col.dataField], {
              formatType: dataRow.is_merge && col.dataField == mergeDataField ? 0 : col.formatType,
              optionFormat: col.optionFormat,
              enumName: col.enum,
              dataRow: dataRow,
            })
          "
          @click="viewLinkedForm(col, dataRow)"
        >
          {{
            dataRow[col.dataField] || (dataRow[col.dataField] == 0 && isShowZero)
              ? $ms.format.formatData(dataRow[col.dataField], {
                  formatType: dataRow.is_merge && col.dataField == mergeDataField ? 0 : col.formatType,
                  optionFormat: col.optionFormat,
                  enumName: col.enum,
                  isShowZero: isShowZero,
                  dataRow: dataRow,
                })
              : ''
          }}
        </span>

        <!-- <div
          :class="['mi', 'mi-24', col.icon.type]"
          v-if="col.icon && col.icon.show(dataRow, col)"
          v-tooltip="{ ...col.icon.tooltip }"
        ></div> -->
      </div>
    </td>
    <td
      v-if="$slots.widget"
      :key="100"
      class="ms-td widget-item sticky"
      :class="[dataRow?.widget?.class ? dataRow?.widget?.class : '']"
      :rowspan="dataRow?.widget?.rowspan ?? 1"
    >
      <slot name="widget" />
    </td>
  </tr>
</template>
<script>
import {ref, defineAsyncComponent, getCurrentInstance, inject, computed} from 'vue';
export default {
  name: 'MsTr',
  components: {},
  props: {
    isShowZero: {
      default: true,
      type: Boolean,
    },
    // Lưu thông tin của các cột
    columns: {},
    // Lưu dữ liệu của dòng
    dataRow: {},
    // Ẩn/hiện cột checkbox tích chọn nhiều cột
    multiple: {
      default: false,
      type: Boolean,
    },
    // Trạng thái tích chọn ở cột multiple
    isSelected: {
      default: false,
      type: Boolean,
    },
    index: {
      default: null,
      type: Number,
    },
    serial: {
      default: false,
      type: Boolean,
    },
    currentPage: {
      default: 1,
      type: Number,
    },
    pageSize: {
      default: 20,
      type: Number,
    },
    rowSelected: {
      default: null,
    },
    rowActions: {
      default: null,
      type: [Object, Array],
    },
    actionInlineCount: {
      type: Number,
    },
    disabledCheckedMultipleTbody: {
      default: false,
      type: [Boolean, Function],
    },
    hasLockColumn: {
      type: Boolean,
      default: false,
    },
    isCheckedAll: {
      default: () => false,
      type: Boolean,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    groupField: {
      default: [],
      type: Array,
    },
    /**
     * Check có sử dụng style của dữ liệu không
     * NMDUC1 16/10/2023
     */
    isUseDataRowStyle: {
      default: false,
      type: Boolean,
    },
    /**
     * Truyền vào cột thực hiện merge để ghi đè foramt
     * NMDUC1 24/10/2023
     */
    mergeDataField: {
      type: String,
      default: null,
    },
    isUseCustomStyleDataRow: {
      default: false,
      type: Boolean,
    },
  },

  setup(props, {emit}) {
    const {proxy} = getCurrentInstance();

    /**
     * Bổ sung custom span
     */
    const spanMethod = inject('spanMethod');

    /**
     * Loại bỏ các column ko có span
     */
    const columnx = computed(() => {
      if (!props.columns) return [];
      const cols = [];
      props.columns.forEach((col, i) => {
        const {colspan, rowspan} = getSpan(col, props.dataRow, i);
        if (colspan) {
          cols.push({...col, ...{colspan: colspan, rowspan: rowspan}, colIndex: i});
        }
      });
      return cols;
    });
    /**
     * Get span của ô
     */
    const getSpan = (col, dataRow, colIndex) => {
      const defaultSpanObj = {colspan: 1, rowspan: 1};
      if (typeof spanMethod === 'function') {
        const spanObj = spanMethod(col, dataRow, colIndex);
        if (!spanObj) return defaultSpanObj;
        return spanObj;
      }
      return defaultSpanObj;
    };
    return {getSpan, columnx};
  },

  data() {
    return {
      /**
       * Hiển thị row action không
       */
      showRowAction: false,
      /**
       * Style đặt vị trí hiển thị row action
       */
      rowActionStyle: {
        top: 0,
        left: 0,
      },
    };
  },
  computed: {
    /**
     * Action hiển thị trên dòng chọn ngay
     */
    actionInline() {
      const result = [];
      const actions = this.rowActions;

      if (actions) {
        if (actions.length > this.actionInlineCount) {
          for (let i = 0; i < this.actionInlineCount - 1; i++) {
            result.push(actions[i]);
          }

          result.push({
            command: 'MORE',
            icon: 'more',
            text: this.moreText,
          });
        } else {
          for (let i = 0; i < actions.length; i++) {
            result.push(actions[i]);
          }
        }
      }

      return result;
    },
    /**
     * Action hiển trong more context
     */
    actionContext() {
      const result = [];
      const actions = this.rowActions;

      if (actions && actions.length > this.actionInlineCount) {
        for (let i = this.actionInlineCount - 1; i < actions.length; i++) {
          result.push(actions[i]);
        }
      }

      return result;
    },
    /**
     * Nếu có check all sẽ thực hiện check all
     */
    isChecked() {
      const {disabledCheckedMultipleTbody, isCheckedAll, isSelected, dataRow} = this;
      return disabledCheckedMultipleTbody || dataRow.isDisabledCheckBox ? false : isCheckedAll || isSelected;
    },
  },
  created() {
    const me = this;
    me.moreText = me.$t('i18nCommon.Command.More');
  },
  methods: {
    // Cập nhật lại độ rộng của cột theo độ rộng cấu hình
    // Created by LTDAT
    styleWidth(col, widget, dataRow = null) {
      const rs = {};

      if (col.lock) {
        rs.left = (col.stickyOffset || 0) + 'px';
      }

      if (!widget) {
        rs['max-width'] = col.width + 'px';
      }
      if (dataRow && this.isUseCustomStyleDataRow) {
        switch (col?.formatType) {
          case this.$ms.constant.FormatType.Amount:
          case this.$ms.constant.FormatType.Quantity:
          case this.$ms.constant.FormatType.UnitPrice:
            if (dataRow.font_style_number) {
              rs['font-family'] = dataRow.font_style_number;
            }
            if (dataRow.font_size_number) {
              rs['font-size'] = dataRow.font_size_number + 'px';
            }
            break;
          default:
            if (dataRow.font_style_text) {
              rs['font-family'] = dataRow.font_style_text;
            }
            if (dataRow.font_size_text) {
              rs['font-size'] = dataRow.font_size_text + 'px';
            }
            break;
        }
      }
      this.$emit('styleColumn', col, this.dataRow, rs);

      return rs;
    },

    drilldownClick(col, dataRow, e) {
      const metaData = {
        col: col,
        dataRow: dataRow,
      };
      this.$emit('drilldownClick', metaData, e);
    },

    // (Click vào các cột có dạng số nhiều.(đại diện cho nhiều dòng chi tiết)
    // Created by TVLOI 22.05.2021
    viewMoreDetails(col, dataRow, e) {
      dataRow.moreDetails = true;
      const metaData = {
        col: col,
        dataRow: dataRow,
      };
      this.$emit('viewMoreDetails', metaData, e);
    },

    /**
     * Hiển thị form chi tiết khi click vào ô (nếu có config linkedForm)
     * dtnga3 (14.07.2022)
     */
    viewLinkedForm(col, dataRow, e) {
      // bổ sung nếu dataRow có trường disabled_link_form thì không edmit
      if (col && col.linkedForm && col.linkedForm != '' && !dataRow.disabled_link_form) {
        this.$emit('viewLinkedForm', col, dataRow, e);
      }
    },

    /**
     * Xử lý các sự kiện của HTML khi được binding lên và click vào
     * npcuong 17.04.2023
     */
    customHtmlAction(col, dataRow, e) {
      this.$emit('customHtmlAction', col, dataRow, e);
    },

    // Emit sự kiện ấn phím ra ngoài grid
    // Created by LTDAT(13/06/2020)
    row_keydown(e) {
      const me = this;
      me.$emit(me.$ms.constant.CustomEvent.MsKeydown, me.dataRow, e);
    },

    // Sự kiện click vào nút chọn ở cột multiple
    // Created by LTDAT (28.05.2020)
    // NCPHUOC 28/03/2022: emit checkbox event ra ngoài grid
    checkMultiple(e) {
      const me = this;
      const checked = e.target.tagName.toLowerCase() === 'input' ? e.target.checked : false;
      me.$emit('clickMultiple', me.dataRow, checked, e);
    },

    /**
     * Show tooltip cho nội dung cell
     */
    titleToolTip(dataRow, col) {
      return '';
    },
    /**
     * convert html code to text
     */
    stripHtml(source) {
      let output;
      source = source.toString();
      // get rid of HTML tags
      output = source.replace(/<[^>]*>/g, '');
      output = output.replace(/&nbsp;/g, ' ');
      output = output.replace(/\n/g, '; ');
      return output;
    },
    showActionSub(action, event) {
      const me = this;
      if (action.subMenu) {
        let liPersent = event.toElement;
        if (liPersent) {
          while (!liPersent.className.contains('actionSub')) {
            liPersent = liPersent.offsetParent;
          }
          const liPosition = liPersent.getBoundingClientRect(); // Position của thẻ li (action cha)
          const [menuSub] = me.$refs.actionSubMenu; // Position menu sub
          const elSub = menuSub.$el; // element sub
          const elSubPosition = menuSub.$el.getBoundingClientRect(); // Position của menusub
          if (elSub) {
            // gán lại style cho  element sub, đang tạm gán thôi, chưa tính trường hợp dàn lên trên nếu top quá to hoặc dàn sang phải nếu left quá nhỏ
            elSub.style.top = liPosition.top + 'px';
            elSub.style.left = liPosition.left - elSubPosition.width + 'px';
          }
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/components/MsTrViewer.scss';
</style>
